import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Sheets } from "@/components/site/Sheets";
import Brand from "@/pages/Brand";

const Home = () => (
  <>
    <Nav />
    <Sheets />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brand" element={<Brand />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
